import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

/**
 * @param {string} label - Texto do label
 * @param {any} value - Valor atual do select (null quando vazio)
 * @param {function} onChange - Callback quando o valor muda
 * @param {function} onClear - Callback quando o botão limpar é clicado
 * @param {string} labelId - ID do label (para acessibilidade)
 * @param {string} selectId - ID do select
 * @param {object} style - Estilos adicionais para o FormControl
 * @param {React.ReactNode} children - MenuItem components
 */

export default function SelectWithClear({
    label,
    value,
    onChange,
    onClear,
    labelId = "select-label",
    selectId = "select",
    style = {},
    children,
    ...otherProps
}) {
    const [focused, setFocused] = useState(false);
    const [hovered, setHovered] = useState(false);
    const hasValue = value !== null && value !== undefined;

    const handleClear = (e) => {
        e.stopPropagation();
        if (onClear) {
            onClear();
        }
    };

    const handleBlur = () => {
        setFocused(false);
        setHovered(false);
    };

    return (
        <FormControl style={{ width: "100%", marginBottom: 24, ...style }}>
            <InputLabel id={labelId} shrink={hasValue || focused}>
                {label}
            </InputLabel>
            <Select
                labelId={labelId}
                id={selectId}
                value={hasValue ? value : ""}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={handleBlur}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                label={label}
                displayEmpty
                notched={hasValue || focused}
                endAdornment={
                    hasValue && (focused || hovered) && (
                        <IconButton
                            size="small"
                            style={{
                                marginRight: 24,
                                padding: 4,
                                transition: "opacity 0.15s ease-in-out",
                            }}
                            onClick={handleClear}
                        >
                            <img
                                src="/img/modal_close.svg"
                                alt="Limpar"
                                style={{
                                    width: 20,
                                    height: 20,
                                    display: "block",
                                }}
                            />
                        </IconButton>
                    )
                }
                {...otherProps}
            >
                {children}
            </Select>
        </FormControl>
    );
}
